import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'
import address from '@/store/shared/address'

export default {
  namespaced: true,
  state () {
    return {
      code: '',
      description: '',
      name: '',
      firstname: '',
      lastname: ''
    }
  },
  actions,
  getters,
  modules: {
    address
  },
  mutations
}
